import "react-datepicker/dist/react-datepicker.css";
import "./CalendarInputV2.scss";

import React, { useMemo } from "react";

import { Calendar } from "primereact/calendar";
import { addLocale } from "primereact/api";
import { formatDateInEN } from "../util/HallAppUtil";

addLocale("pt", {
  firstDayOfWeek: 1,
  dayNames: ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"],
  dayNamesShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
  dayNamesMin: ["D", "S", "T", "Q", "Q", "S", "S"],
  monthNames: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
  monthNamesShort: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
  today: "Hoje",
  clear: "Limpar",
  dateFormat: "dd/mm/yyyy",
  weekHeader: "Sem",
});

const isBlank = (v) => v == null || String(v).trim() === "";

const CalendarInputV2 = ({
  // prime
  values,
  setDates,
  changeDates,

  selectionMode = "range", // "single" | "range"
  dateFormat = "dd/mm/yy",
  maxDate,

  // visual padrão HallApp
  name,
  label = "Data",
  placeholder,
  isRequired = false,

  errors = {},
  touched = false,

  disabled = false,
  readOnly = true, // no seu caso você usa readOnlyInput
  leftIcon,

  className = "",
}) => {
  const hasError = !!errors?.[name] && !!touched;

  function onChangeDates(dates) {
    if (selectionMode === "single") {
      changeDates?.(formatDateInEN(dates));
      setDates?.(dates);
    } else {
      const [startDate, endDate] = dates || [];
      setDates?.(dates);
      changeDates?.(formatDateInEN(startDate), formatDateInEN(endDate));
    }
  }

  const resolvedPlaceholder = useMemo(() => {
    if (!isBlank(placeholder)) return placeholder;
    return selectionMode === "single" ? "Selecione a data" : "Selecione o período";
  }, [placeholder, selectionMode]);

  return (
    <div className={`hallapp-calendarv2 ${className} ${disabled ? "is-disabled" : ""} ${hasError ? "is-error" : ""}`}>
      {label && (
        <div className="hallapp-calendarv2__label">
          <span>{label}</span>
          {isRequired && <span className="hallapp-calendarv2__required"> *(obrigatório)</span>}
        </div>
      )}

      <div className={`hallapp-calendarv2__wrap ${readOnly ? "is-readonly" : ""}`}>
        {leftIcon ? <div className="hallapp-calendarv2__iconLeft">{leftIcon}</div> : null}

        <Calendar
          style={{ width: "100%" }}
          className="hallapp-calendarv2__calendar"
          inputClassName="hallapp-calendarv2__input"
          locale="pt"
          dateFormat={dateFormat}
          value={values}
          maxDate={maxDate}
          disabled={disabled}
          onChange={(e) => onChangeDates(e.value)}
          selectionMode={selectionMode}
          placeholder={resolvedPlaceholder}
          readOnlyInput
          hideOnRangeSelection
          showIcon={false}
        />
      </div>

      <div className="hallapp-calendarv2__meta">
        {hasError ? <div className="hallapp-calendarv2__error">{errors?.[name]}</div> : <span />}
      </div>
    </div>
  );
};

export default CalendarInputV2;
